import React, { useState, useEffect, useRef } from 'react';
import { Card, CircularProgress } from '@mui/material';
import { GoogleMap, MarkerF, useJsApiLoader, } from '@react-google-maps/api'
import { CONFIG_SETTINGS } from '../../../config';

const containerStyle = {
    width: '100%',
    height: '250px'
};

/**
 * @module Layouts/Registration/components/GoogleMapSection
 * @description This is a functional component in JavaScript React that renders a Google Map with a marker at a
specific location. The component takes in two props: `address` and `onUpdateMapPoint`. The `address`
prop is an object that contains the latitude and longitude of the location to be displayed on the
map. The `onUpdateMapPoint` prop is a function that is called when the user selects a point on the
map.
 * @returns {React.ReactElement} The `GoogleMapSection` component is being returned as a View.
 */

/**
 * 
 * @typedef GoogleMapSection
 * @property {MUIStyles} classes - The styles for the component 
 * @property {Object} address - The address element as an object
 * @property {Number} address.id - The id of the address
 * @property {String} address.latitude - Latitude of address data
 * @property {String} address.longitude - Longitude of address data
 * @property {Function} onUpdateMapPoint - This function is dispatched when a mark inside Google Map is clicked
 

 * @returns {React.ReactElement} The `GoogleMapSection` component is being returned as a View.
 */


const GoogleMapSection = ({address, onUpdateMapPoint}) => {

     const [center, setCenter] = useState({lat:19.4326, lng:-99.1332})
     const [position, setPosition] = useState({lat:19.4326, lng:-99.1332})
     const [zoom, setZoom] = useState(13)
     const googleMapRef = useRef()
    //console.log(CONFIG_SETTINGS.GOOGLE_MAP_KEY )

     const { isLoaded, loadError } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: CONFIG_SETTINGS.GOOGLE_MAP_KEY //GOOGLE_API_KEY // ,
        // ...otherOptions
    })

    useEffect(() => {
        //console.log('Error load', loadError)
    }, [loadError])

    useEffect(() => {
        //console.log('Is loaded', isLoaded)
    }, [isLoaded])

    useEffect(() => {
        window.scrollTo(0,0)
        //console.log(googleMapRef.current)
    }, [])

    useEffect(() => {
        /**
         * The function sets the center and position of a map based on a given address.
         */
        const onCalculatePoint = async() => {
            if(address){
                let _center = {
                    lat:parseFloat(address.latitude ? address.latitude : 19.4326),
                    lng:parseFloat(address.longitude ? address.longitude : -99.1332)
                }
                let _position = {
                    lat:parseFloat(address.latitude ? address.latitude : 19.4326),
                    lng:parseFloat(address.longitude ? address.longitude : -99.1332)
                }

                setCenter(_center)
                setPosition(_position)
            }
        }
        onCalculatePoint()
    }, [address])

    const onPointSelected = (data) => {
        console.log(data)
        onUpdateMapPoint(data)
    }

    //console.log(address)

    const demo_position = {
        lat: 32.5452,
        lng: -117.05343
      }

      const onLoad = marker => {
        //console.log('marker: ', marker)
      }
      

    const google_map_content = isLoaded ? 
        <GoogleMap 
            ref={googleMapRef}
            mapContainerStyle={containerStyle}
            center={center}
            zoom={zoom}>
            <>
                <MarkerF
                    position={
                        {lat:parseFloat(position?.lat), lng:parseFloat(position?.lng)}}
                />
                <MarkerF
                    onLoad={onLoad}
                    position={demo_position}
                />
            </>
        </GoogleMap> : null


    return ( 
        <Card style={{borderRadius:20}}>
            <div >
                {isLoaded ? google_map_content : <CircularProgress size={54}/> }
            </div>
        </Card>
     );
}
 
export default GoogleMapSection;